import { useState } from "react";
import { Mail, X } from "lucide-react";
import { Trans, useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";
import { useToast } from "../../context/ToastContext";
import { authService } from "../../api/services";

// Banner soft: visible para usuarios logueados cuxo email non foi confirmado.
// Non bloquea ningunha acción — só recorda resolvelo.
export default function EmailVerificationBanner() {
  const { t } = useTranslation("home");
  const { user } = useAuth();
  const { addToast } = useToast();
  const [sending, setSending] = useState(false);
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem("emailBannerDismissed") === "1"
  );

  if (!user) return null;
  if (user.emailVerified) return null;
  if (dismissed) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      await authService.resendVerification(user.email);
      addToast(t("emailBanner.resendSuccess"), "success");
    } catch (err) {
      addToast(t("emailBanner.resendErrorPrefix") + err.message, "error");
    } finally {
      setSending(false);
    }
  };

  const handleDismiss = () => {
    sessionStorage.setItem("emailBannerDismissed", "1");
    setDismissed(true);
  };

  return (
    <div className="bg-yellow-50 border-b border-yellow-200">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center gap-3 text-sm">
        <Mail size={16} className="text-yellow-700 shrink-0" />
        <div className="flex-1 min-w-0">
          <span className="text-yellow-900 font-medium">
            {t("emailBanner.title")}
          </span>
          <span className="text-yellow-800 hidden sm:inline">
            <Trans
              i18nKey="home:emailBanner.details"
              values={{ email: user.email }}
              components={[<strong key="0" />]}
            />
          </span>
        </div>
        <button
          onClick={handleResend}
          disabled={sending}
          className="shrink-0 px-3 py-1 rounded-lg bg-yellow-700 text-white text-xs font-semibold hover:bg-yellow-800 transition-colors disabled:opacity-50"
        >
          {sending ? t("emailBanner.resending") : t("emailBanner.resend")}
        </button>
        <button
          onClick={handleDismiss}
          className="shrink-0 p-1 text-yellow-700 hover:text-yellow-900 transition-colors"
          title={t("emailBanner.dismissTitle")}
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
